<template>
    <v-container class="ma-0 pa-0">
        <v-row >
            <v-col cols="12">
                <v-progress-linear v-if="loading" color="primary" indeterminate></v-progress-linear>
                <v-form @submit.prevent v-else ref="editForm" v-model="editMedicalObservationValid">
                    <v-row >
                        <v-col cols="12">
                            <v-autocomplete
                                :items="observationTypes"
                                item-text="MedicalObservationTypeName"
                                item-value="MedicalObservationTypeID"
                                v-model="medicalObservation.MedicalObservationTypeID"
                                :rules="[rules.selectIDRequired]"
                                label="Observation Type"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-if="medicalObservation.MedicalObservationTypeID===26"
                                clearable
                                v-model="medicalObservation.OtherTypeDescription"
                                :rules="[rules.required]"
                                label="Observation Description">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                clearable
                                maxlength="8000"
                                v-model="medicalObservation.Comment"
                                label="Comment">
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-btn block :color="useCurrentTime ? 'accent' : ''" :disabled="saving" @click="toggleUseCurrentTime()">
                                <span v-if="useCurrentTime">Using Current Time (press to change)</span>
                                <span v-else>Press to use current time</span>
                                <v-icon v-if="useCurrentTime" right>check_circle</v-icon>
                                <v-icon v-else right>close</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="!useCurrentTime">
                            <v-menu
                                ref="datePickerMenu"
                                :close-on-content-click="false"
                                v-model="datePickerMenu"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        clearable
                                        v-model="displayDate"
                                        label="Date"
                                        prepend-icon="event"
                                        readonly
                                        :rules="[rules.required]"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    :allowed-dates="allowedDates"
                                    v-model="medicalObservation.Date"
                                    @input="datePickerMenu = false"
                                    :title-date-format="datePickerFormat"
                                >
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="!useCurrentTime">
                            <v-menu
                                ref="timePickerMenu"
                                v-model="timePickerMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="medicalObservation.Time"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        clearable
                                        v-model="medicalObservation.Time"
                                        label="Time"
                                        prepend-icon="access_time"
                                        readonly
                                        :rules="[rules.required]"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="timePickerMenu"
                                    v-model="medicalObservation.Time"
                                    format="24hr"
                                    @click:minute="$refs.timePickerMenu.save(medicalObservation.Time)"
                                ></v-time-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row  class="dialog-action-buttons">
                        <!-- <v-flex xs12 md6>
                            <v-btn block color="accent" :disabled="saving" @click="setTimeToNow()">Set time to Now</v-btn>
                        </v-flex> -->
                        <v-col cols="12" md="6">
                            <v-btn block color="error" :disabled="saving" @click="clearAddMedicalObservation(true)">Clear</v-btn>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-btn block color="success" :disabled="!editMedicalObservationValid" :loading="saving" @click="saveMedicalObservation">Save</v-btn>
                        </v-col>
                        <v-col cols="12" v-if="saveError">
                            <v-alert text type="error">{{ saveError }}</v-alert>
                        </v-col>
                        <v-col cols="12">
                            <success-alert content="Successfully added Medical Observation" :display="showSaveSuccess"></success-alert>
                        </v-col>
                    </v-row>     
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<style>

</style>

<script>
import validationRules from "../../helpers/validationrules";
import SuccessAlert from "../common/SuccessAlert";
import util from '@/helpers/util';
import constants from 'comunet-btg-utah-repository-shared/constants';

import moment from 'moment';

export default {
    components: {
        SuccessAlert
    },
    props: {
        specimenID: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            medicalObservation: {},
            datePickerMenu: false,
            timePickerMenu: false,
            rules: validationRules.rules,
            editMedicalObservationValid: false,
            showSaveSuccess: false,
            useCurrentTime: true
        };
    },
    computed: {
        loading() {
            return this.$store.state.dailyHusbandryStore.loadingMedicalObservationTypes;
        },
        saving() {
            return this.$store.state.dailyHusbandryStore.savingMedicalObservation;
        },
        saveError() {
            return this.$store.state.dailyHusbandryStore.saveMedicalObservationError;
        },
        observationTypes() {
            return [...this.$store.state.dailyHusbandryStore.medicalObservationTypes].sort(util.sortByField("MedicalObservationTypeName", ["Other"]));
        },
        displayDate: {
            get: function() {
                if (this.medicalObservation && this.medicalObservation.Date) {
                    return moment.utc(this.medicalObservation.Date).format(constants.DATE_FORMAT_NO_TIME);
                }
                
                return "";
            },
            set: function(newValue) {
                this.medicalObservation.Date = newValue;
            }
        }
    },
    methods: {
        datePickerFormat(date) {
            return moment.utc(date).format(constants.DATE_FORMAT_NO_TIME);
        },
        toggleUseCurrentTime() {
            this.setTimeToNow();

            this.useCurrentTime = !this.useCurrentTime;
        },
        loadMedicalObservationTypes() {
            this.$store.dispatch("dailyHusbandryStore/loadMedicalObservationTypes");
        },
        allowedDates() {
            // no restriction on allowed dates
            return true;
        },
        setTimeToNow() {
            this.medicalObservation.Date = moment().format("YYYY-MM-DD");
            this.medicalObservation.Time = moment().format("HH:mm");
        },
        clearAddMedicalObservation(revalidate) {
            // return form to current time, with no comment or type selected
            this.useCurrentTime = true;

            this.medicalObservation = {
                SpecimenID: this.specimenID,
                Date: moment().format("YYYY-MM-DD"),
                Time: moment().format("HH:mm")
            };

            if (this.$refs && this.$refs.editForm) {
                if (revalidate) {
                    this.$refs.editForm.validate();
                }
            }
        },
        saveMedicalObservation() {
            // clear the success message
            this.showSaveSuccess = false;

            // if we are using the current time, set the selected time to now right before we save
            if (this.useCurrentTime) {
                this.setTimeToNow();
            }

            var that = this;

            this.$store.dispatch("dailyHusbandryStore/saveMedicalObservation", {
                medicalObservation: this.medicalObservation,
                finally: function() {
                    if (that.$store.state.dailyHusbandryStore.saveMedicalObservationError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.clearAddMedicalObservation();

                        // this functionality has been removed, because we are now closing the expansion panel when a record has been successfully added
                        // show a success message
                        //that.showSaveSuccess = true;

                        // refresh the data on the husbandry page (in multiple different components)
                        that.$emit("onSaved");
                    }
                }
            });
        }
    },
    created() {
        this.clearAddMedicalObservation();
        this.loadMedicalObservationTypes();
    }
};
</script>